import "./style/main.scss";
import Router from "./Routes/Router";
import "react-quill/dist/quill.snow.css";
import { AuthProvider } from "./Context/AuthContext";

function App() {
    return (
        <AuthProvider>
            <div className="h-full">
                <Router />
            </div>
        </AuthProvider>
    );
}

export default App;
